<template>
  <v-navigation-drawer
      id="core-navigation-drawer"
      v-model="drawer"
      v-bind="$attrs"
      :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
      :expand-on-hover="expandOnHover"
      :right="$vuetify.rtl"
      :src="barImage"
      hide-overlay
      app
      mobile-breakpoint="960"
      mini-variant-width="180"
      width="180"
  >
    <template v-slot:img="props">
      <v-img
          v-bind="props"
          :gradient="`to bottom, ${barColor}`"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <!--                <v-list-item-title class="text-uppercase font-weight-regular display-2">-->
        <!--&lt;!&ndash;                    <span class="logo-mini">{{ $t('katarynka-ct.pl') }}</span>&ndash;&gt;-->
        <v-img :src="logo"/>        <!--                </v-list-item-title>-->
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1"/>

    <v-list
        dense
        nav
    >
      <base-item-group :item="profile"/>
    </v-list>

    <v-divider class="mb-2"/>

    <v-list
        expand
        nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>

      <template v-for="(item, i) in computedItems">
        <base-item-group
            v-if="item.children"
            :key="`group-${i}`"
            :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
            v-else
            :key="`item-${i}`"
            :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {mapState,} from 'vuex'
import ItemGroup from "../../../base/ItemGroup";
import Item from "../../../base/Item";
import {eventBus} from "@/services/event-bus";

export default {
  name: 'DashboardCoreDrawer',

  components: {
    baseItemGroup: ItemGroup,
    baseItem: Item
  },

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    items: [
    ],
    logo: require('../../../../assets/logo.png')

  }),

  computed: {
    ...mapState(['barColor', 'barImage']),
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
    computedItems() {
      return this.items.map(this.mapItem)
    },
    profile() {
      return {
        avatar: false,
        group: '',
        title: `${this.$store.state.user.party.name} ${this.$store.state.user.party.surname}`,
        children: [
          {
            to: 'logout',
            title: this.$t('logout'),
          },

          // {
          //   to: '',
          //   title: this.$t('my-profile'),
          // },
          // {
          //   to: '',
          //   title: this.$t('edit-profile'),
          // },
          // {
          //   to: '',
          //   title: this.$t('settings'),
          // },
        ],
      }
    },
  },
  mounted() {
    eventBus.$on('set-drawer', (val) => {
      this.$store.state.drawer = val;
    })
  },
  created() {
    const p = JSON.parse(localStorage.getItem('user')).party;
    // eslint-disable-next-line no-console
    console.log(p);
    if (p.type === 'backoffice') {
      this.items.push({
            title: 'summary',
            group: '/summary',
            children: [{
              title: 'summary-scheduler',
              to: 'summary-scheduler',
            }
            // , {
            //   icon: 'mdi-alarm-multiple',
            //   title: 'configurePlanning',
            //   to: 'periods',
            // },
            //   {
            //     icon: 'mdi-calendar-range',
            //     title: 'automatic-scheduler',
            //     to: 'automatic-scheduler',
            //   }
              ]
          }
      );
      // this.items.push({
      //       icon: 'mdi-calendar-range',
      //       title: 'summary-scheduler',
      //       to: 'summary-scheduler',
      //     }
      // );
    }
    if (p.type === 'backoffice') {
      this.items.push({
            title: 'calendars',
            group: '/calendar',
            children: [{
              title: 'therapists',
              to: 'therapist',
            },
              {
                title: 'patients',
                to: 'patient',
              },]
          },
      );
      this.items.push({
            title: 'manage',
            group: '/manage',
            children: [
              {
                title: 'manage-therapists',
                to: 'therapists',
              },
              {
                title: 'manage-patients',
                to: 'patients',
              },
              {
                title: 'manage-activities',
                to: 'activities',
              }
            ]
          },
      );
    } else if (p.type === 'patient' || p.type === 'therapist') {
      this.items.push({
            title: 'calendar',
            to: `/calendar/${p.type}/${p.id}`,
          },
          {
            title: 'manage-patients',
            to: '/manage/patients',
          },
      )
    }
  },

  watch: {
    '$vuetify.breakpoint.smAndDown'(val) {
      this.$emit('update:expandOnHover', !val)
      // eventBus.$emit('set-drawer', !val);
    },
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      }
    },
  },
}
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.v-list-item__title
    font-size: 12px !important

#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 6px
        margin-left: 3px !important

      +rtl()
        margin-left: 6px
        margin-right: 3px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 5px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 2px

      +rtl()
        padding-right: 2px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 9px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 4px

        +rtl()
          margin-left: 4px
</style>
